import { getNextRoute } from '@dvp/helpers/Route'

import basketStore from '@shared/store/basket'

import { ROUTE_INDEX, ROUTE_NAME } from '@shared/config/constants'

export default [
  {
    beforeEnter: (to, _from, next) => {
      if (!basketStore.basket.signature || !basketStore.basket.signature.signatureRequired) {
        next({
          name: getNextRoute(basketStore.basket),
          params: {
            lang: to.params.lang
          }
        })
      } else {
        next()
      }
    },
    name: ROUTE_NAME.SIGNATURE,
    path: 'digital-signature/',
    children: [
      {
        component: () => import('@shared/modules/Dvp/screens/DigitalSignature/ScreenEntry'),
        meta: {
          headerDisabled: true,
          navigation: false,
          index: ROUTE_INDEX.SIGNATURE_ENTRY,
        },
        name: ROUTE_NAME.SIGNATURE_ENTRY,
        path: 'entry',
      },
      {
        component: () => import('@shared/modules/Dvp/screens/DigitalSignature/ScreenVerification'),
        meta: {
          headerDisabled: true,
          navigation: false,
          index: ROUTE_INDEX.SIGNATURE_VERIFICATION,
        },
        name: ROUTE_NAME.SIGNATURE_VERIFICATION,
        path: 'verification',
      },
    ],
  },
]
